<template>
  <div>
    <Row :gutter="16">
      <Col span="8">
        <Select placeholder="一级分类" v-model="pid"  @on-change="changepar">
          <Option v-for="item in list1" :value="item.i1" :label="item.s1"></Option>
        </Select>
      </Col>
      <Col span="14">
        <Select placeholder="二级分类" @on-change="change" v-model="value">
          <Option v-for="item in list2" :value="item.i1" :label="item.s1"></Option>
        </Select>
      </Col>
    </Row>

  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: ''
      },
    },
    data(){
      return{
        list1:[],
        pid:0,
        list2:[],
      }
    },
    methods:{
      load(){
        let that = this;
        this.$axios.get('/api/classify/getparent?type='+this.type).then(function(rs){
          that.list1 = rs.data;
        });
      },
      change(){
        this.$emit('input',this.value);
        this.$emit('on-change');
      },
      changepar(){
        this.list2 = [];
        let that = this;
        this.$axios.get('/api/classify/getbyparent?pid='+this.pid+'&type='+this.type).then(function(rs){
          that.list2 = rs.data;
        });
      }

    },
    created(){
      this.load();
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/common/field/FieldClassify.vue